import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.js";
import es from "./es.js";
import de from "./de.js";
import fr from "./fr.js";
import pt from "./pt.js";

const messages = {
	en,
	es,
	de,
	fr,
	pt,
};

Vue.use(VueI18n);

export default new VueI18n({
	locale: "es",
	messages,
	silentTranslationWarn: process.env.NODE_ENV === "production",
});
